/**
 * Функция для введения информативного сообщения в консоль
 */
export function logInfo(message: string, ...optionalParams: any[]) {
  console.log(message, ...optionalParams);
}

/**
 * Функция для введения сообщения об ошибке в консоль
 */
export function logError(message: string, e: Error | unknown) {
  console.error.apply(console, [message, e]);
}

/**
 * Функция для введения предупрждения в консоль
 */
export function logWarning(message: string, e?: any) {
  console.warn(message, e);
}
